var render = function render(){var _vm=this,_c=_vm._self._c;return _c('r-card',[_c('v-row',{staticClass:"ma-0 pa-2"},_vm._l((_vm.data),function(item,i){return _c('v-col',{key:item.value,staticClass:"pa-2",attrs:{"md":_vm.mdCols(i),"cols":"12"}},[_c('chart-card',{attrs:{"loading":_vm.loading,"previous":_vm.prevValue(item),"title":item.name,"type":item.type,"value":_vm.value(item),"prefix":"₽"}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }